import { Pipe, PipeTransform } from '@angular/core';
import { Assessment, NhptData } from '../services/model';

@Pipe({
  name: 'nhptScore',
  standalone: true,
})
export class NhptScorePipe implements PipeTransform {
  transform(assessment: Assessment, side: 'left' | 'right' | 'none' = 'none', option: 1 | 2 | 3 = 1): number {
    if (assessment.type === 'NHPT') {
      const data = assessment.data as NhptData;
      let value = -1;
      let overtimeCount = -1;
      if (side === 'left') {
        value = data.nhpt.data[0].valueLeft ?? -1;
        overtimeCount = data.nhpt.data[0].overtimeCountLeft ?? -1;
      }
      if (side === 'right') {
        value = data.nhpt.data[0].valueRight ?? -1;
        overtimeCount = data.nhpt.data[0].overtimeCountRight ?? -1;
      }

      if (value > 59) {
        if (option === 3) {
          // Prozentwert
          return Math.round((overtimeCount / 18) * 100);
        } else if (option === 1) {
          // Eingesteckt
          overtimeCount = overtimeCount > 9 ? 9 : overtimeCount;
        } else {
          // Herausgezogen
          overtimeCount = overtimeCount > 18 ? 9 : overtimeCount - 9;
          overtimeCount = overtimeCount < 0 ? 0 : overtimeCount;
          return overtimeCount;
        }
        return overtimeCount;
      } else {
        if (option === 3) {
          return 100;
        }
        return 9;
      }
    } else {
      return 0;
    }
    return 0;
  }
}
